import {SignUpComponent} from "../SignUpComponent.js";
import {InputValidator} from "../../util/input-validate/inputValidation.js";
import {InputErrorHandler} from "../../util/input-error-handler/index.js";


export class Input extends SignUpComponent {

    setEvent() {
        this.addEvent("keyup", this.getInputSelector(), this.keyUpEventHandlerOfInput.bind(this));
        this.addEvent("focusout", this.getInputSelector(), () =>{
            this.inputValidate.bind(this)
        });
        this.interactiveFormFunc();
    }

    getInputSelector() {
        return "input"
    }

    keyUpEventHandlerOfInput(e) {
        const {
            isLast = false,
            submit = Mutil.noop,
            allowBlank = true,
        } = this.$props;

        const input = $(e.target);
        if (Mutil.isAvailableKeyCode(e)) {
            return;
        }
        !allowBlank && InputErrorHandler.removeBlank(input);

        if (!this.inputValidate()) {
            return;
        }

        if (isLast && Mutil.isKey(e, "ENTER")) {
            submit();
            return;
        }
    }

    getInputValue() {
        return this.get$Input().val();
    }

    get$Input() {
        return $(this.getInputSelector());
    }

    inputValidate() {
        return InputValidator.inputValidate(this.get$Input());
    }
}